(() => {
  angular
    .module('gm.common.directives')
    .directive('gmShareTwitterIcon', gmShareTwitterIconDirective);

  function gmShareTwitterIconDirective(
    $window
  ) {
    'ngInject';

    const twitterText = $window.encodeURIComponent('');
    const baseUrl = `http://twitter.com/share?text=${twitterText}&url=`;
    const encodedUrl = $window.encodeURIComponent($window.location.href);

    return {
      replace: true,
      restrict: 'E',
      scope: {},
      templateUrl: 'modules/common/directives/share-twitter-icon/share-twitter-icon.html',

      link(scope) {
        scope.share = () => {
          $window.open(baseUrl + encodedUrl, 'Goldmoney', 'height=300,width=550,resizable=1');
          return true;
        };
      }
    };
  }
})();
